exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".LX__rootToast__self {\n  z-index: 2147483647;\n  position: fixed;\n  top: 0;\n  width: 200px;\n  left: calc(50vw - 100px);\n}\n", "", {"version":3,"sources":["/apps/packages/toast/rootToast.scss"],"names":[],"mappings":"AAAA;EAEE,oBAAmB;EACnB,gBAAe;EACf,OAAM;EACN,aAJa;EAKb,yBAA8B;CAC/B","file":"rootToast.scss","sourcesContent":[".self {\n  $width: 200px;\n  z-index: 2147483647; // max possible value\n  position: fixed;\n  top: 0;\n  width: $width;\n  left: calc(50vw - #{$width/2});\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"self": "LX__rootToast__self"
};